module.exports = __webpack_public_path__ + "img/63.8.TSS.db59e09e.png";